import { reduxActions as UI } from "_constants/ui.constants";

export const keyboardShortcut =
  ({ type, action }) =>
  (dispatch) =>
    dispatch({ type: UI.KEYBOARD_SHORTCUTS, payload: { type, action } });
export const changePageDetails = (page) => (dispatch) =>
  dispatch({ type: UI.CHANGE_DETAILS_PAGE, payload: page });
